import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'

import { localize, localizeWithVars } from 'helpers/translator/localize'
import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import adminOnboardingOverlaySelector from 'redux/selectors/admin_onboarding/admin_onboarding_overlay_selector'

import styles from './school_free_trial_onboarding_overlay.scss'

class SchoolFreeTrialOnboardingOverlay extends PureComponent {

	componentDidMount() {
		this.props.actions.overlaySchoolTrialOnboardingInitialize()
	}

	componentWillUnmount() {
		this.props.actions.overlaySchoolTrialOnboardingClose()
	}

	createTitle() {
		return (
			<span styleName='title'>
				<strong styleName='strong'>{localize('school_free_trial_overlay_admin_title_part1')} </strong><br />
				{localizeWithVars('school_free_trial_overlay_admin_title_part2', { days: this.props.durationDays })}
			</span>
		)
	}

	createAsset(url) {
		return (
			<div styleName='asset'>
				<iframe
					width='100%'
					height='302'
					src={url}
					frameBorder='0'
					allow='encrypted-media'
					allowFullScreen
				></iframe>
			</div>
		)
	}

	render() {

		if (!this.props.durationDays)
			return null

		return (
			<FullOverlay
				headerWithBorder={true}
				title={this.createTitle()}
				assetSource={this.createAsset(localize('school_trial_onboarding_admin_video'))}
				primaryTextButton={localize('school_free_trial_overlay_admin_primary_button')}
				primaryActionHandler={this.props.actions.overlaySchoolTrialOnboardingConfirm}
				secondaryTextButton={this.props.isTrialFromSF ? localize('school_free_trial_overlay_user_secondary_button_sf') : localize('school_free_trial_overlay_user_secondary_button')}
				secondaryActionHandler={this.props.actions.overlaySchoolTrialOnboardingDismiss}
			/>
		)
	}
}

function mapStateToProps(state) {
	return adminOnboardingOverlaySelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		overlaySchoolTrialOnboardingInitialize: myLibraryActions.overlaySchoolTrialOnboardingInitialize,
		overlaySchoolTrialOnboardingConfirm: myLibraryActions.overlaySchoolTrialOnboardingConfirm,
		overlaySchoolTrialOnboardingDismiss: myLibraryActions.overlaySchoolTrialOnboardingDismiss,
		overlaySchoolTrialOnboardingClose: myLibraryActions.overlaySchoolTrialOnboardingClose,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(SchoolFreeTrialOnboardingOverlay, styles, {allowMultiple: true}))

export { SchoolFreeTrialOnboardingOverlay }
